import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import getDisplayName from '../helpers/componentName';

function loadableFactory(LoaderComponent) {
  return function (LoadableComponent, text) {
    var ComponentWithLoader = function ComponentWithLoader(props) {
      return React.createElement(LoaderComponent, {
        show: props.showLoader,
        text: text
      }, React.createElement(LoadableComponent, _.omit(props, ['children', 'showLoader'])));
    };

    ComponentWithLoader.displayName = 'Loadable(' + getDisplayName(LoadableComponent) + ')';
    ComponentWithLoader.propTypes = {
      showLoader: PropTypes.bool.isRequired
    };
    return ComponentWithLoader;
  };
}

export default loadableFactory;